import { createContext } from 'react';
import { FieldValidationError } from '@/lib/heyapi/types.gen';

export const RatingErrorsContext = createContext<{
  errors: Array<FieldValidationError> | null;
  setErrors: (errors: Array<FieldValidationError>) => void;
}>({
  errors: null,
  setErrors: () => {},
});
